module.exports = __webpack_public_path__ + "static/media/store-display-banner4.7ec6ad42.png";